import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { guaranteeItems } from "../../data/content";
export function GuaranteeSection() {
  return <section className="bg-paper px-4 py-16 sm:py-24" data-id="element-183" data-mp="1kb2gy3fa9p8g">
      <div className="mx-auto max-w-3xl text-center" data-id="element-184" data-mp="1k9j1ug5d5k89">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full bg-navy ring-8 ring-gold" data-id="element-185" data-mp="1fbpzjy76lad9">
          <ShieldCheckIcon className="h-10 w-10 text-gold" aria-hidden="true" data-id="element-186" data-mp="1aezhj5btg4p7" />
          <span className="mt-1 text-lg font-black leading-none text-white" data-id="element-187" data-mp="15dtp78m2ijg7">7 DAYS</span>
        </div>
        <h2 className="mt-6 text-balance font-display text-[30px] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-188" data-mp="11dsz2qplwjtb">
          Your 7-Day Money-Back Guarantee
        </h2>
        <p className="mt-3 text-xl font-bold text-[#0A7FBF]" data-id="element-189" data-mp="2vrao6i5ntoqg">Explore the system without taking a financial risk</p>
        <p className="mt-4 text-lg leading-relaxed text-navy/75" data-id="element-190" data-mp="2qszc00rw7252">
          I want you to have the opportunity to review the materials and decide whether they fit your workflow. During the
          first seven days after purchase, you can:
        </p>

        <ul className="mx-auto mt-6 grid max-w-md gap-3 text-left" data-id="element-191" data-mp="1745co0dt0qa1">
          {guaranteeItems.map(g => <li key={g} className="flex items-center gap-3 text-[17px] font-semibold text-navy" data-id="element-192" data-mp="1c2yozphcub8m">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-193" data-mp="1zt2u61a6yj1q">
                <CheckIcon className="h-4 w-4 text-ink" strokeWidth={3.5} aria-hidden="true" data-id="element-194" data-mp="23u664cp4buxo" />
              </span>
              {g}
            </li>)}
        </ul>

        <p className="mt-6 text-lg leading-relaxed text-navy/75" data-id="element-195" data-mp="1q16tqjkmuguc">
          If you decide the product isn't right for you, contact us within seven days of purchase and request a refund in
          accordance with the guarantee terms.
        </p>

        <div className="mt-10" data-id="element-196" data-mp="2njgnrw8fcpyf">
          <CTAButton label="Try it risk-free" sublabel="Protected by the 7-day guarantee" data-id="element-197" data-mp="2njq4et7kxkrg" />
        </div>
      </div>
    </section>;
}